import { Sun, Moon, Monitor } from 'lucide-react';
import { Theme } from '@/contexts/ThemeContext';
import { cn } from '@/lib/utils';

interface FooterProps {
  theme: Theme;
  setTheme: (theme: Theme) => void;
  showThemeMenu: boolean;
  setShowThemeMenu: (show: boolean) => void;
}

export function Footer({ theme, setTheme, showThemeMenu, setShowThemeMenu }: FooterProps) {
  const getThemeIcon = () => {
    switch (theme) {
      case 'light':
        return <Sun className="h-5 w-5" />;
      case 'dark':
        return <Moon className="h-5 w-5" />;
      case 'system':
        return <Monitor className="h-5 w-5" />;
    }
  };

  return (
    <div className="px-4 sm:px-6 py-4">
      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-3">
          <img
            src="/aipc-final.svg"
            alt="Logo"
            className="h-6 dark:invert"
          />
          <p className="text-sm text-gray-600 dark:text-gray-400">
            © {new Date().getFullYear()} AI Prime Consulting. All rights reserved.
          </p>
        </div>
        <div className="relative">
          <button
            onClick={() => setShowThemeMenu(!showThemeMenu)}
            className="p-2 text-gray-500 dark:text-gray-400 hover:text-gray-600 dark:hover:text-gray-300 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-700"
            aria-label="Theme settings"
          >
            {getThemeIcon()}
          </button>

          {showThemeMenu && (
            <div className="absolute bottom-full right-0 mb-2 w-48 bg-white dark:bg-gray-800 rounded-md shadow-lg py-1 border border-gray-200 dark:border-gray-700 z-50">
              <button
                onClick={() => {
                  setTheme('light');
                  setShowThemeMenu(false);
                }}
                className="flex items-center px-4 py-2 text-sm text-gray-700 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-700 w-full"
              >
                <div className="w-4 h-4 mr-2 flex items-center justify-center">
                  {theme === 'light' && (
                    <div className="w-2 h-2 rounded-full bg-blue-500" />
                  )}
                </div>
                <Sun className="h-4 w-4 mr-2" />
                <span>Light</span>
              </button>
              <button
                onClick={() => {
                  setTheme('dark');
                  setShowThemeMenu(false);
                }}
                className="flex items-center px-4 py-2 text-sm text-gray-700 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-700 w-full"
              >
                <div className="w-4 h-4 mr-2 flex items-center justify-center">
                  {theme === 'dark' && (
                    <div className="w-2 h-2 rounded-full bg-blue-500" />
                  )}
                </div>
                <Moon className="h-4 w-4 mr-2" />
                <span>Dark</span>
              </button>
              <button
                onClick={() => {
                  setTheme('system');
                  setShowThemeMenu(false);
                }}
                className="flex items-center px-4 py-2 text-sm text-gray-700 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-700 w-full"
              >
                <div className="w-4 h-4 mr-2 flex items-center justify-center">
                  {theme === 'system' && (
                    <div className="w-2 h-2 rounded-full bg-blue-500" />
                  )}
                </div>
                <Monitor className="h-4 w-4 mr-2" />
                <span>System</span>
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}